import {initWebComponent} from "@/helpers/web-component-helper";
import {setGeoJsonLayerSegments} from "@/helpers/ol/ol-geo-json-helper";
import {setSegmentStyleVisible} from "@/helpers/tools/tools-measure-helper";

export class LayerInfoInfoItemGeometryMeasureSegmentsComponent extends HTMLElement {
    constructor(){
        super();

        const featureIndex = this.getAttribute('data-feature-index')
        const index = this.getAttribute('data-index')

        const template = document.createElement('template');

        template.innerHTML = `<div class="col-12"><button class="btn btn-outline-secondary popper-header btn-block text-transform-none">Toon/verberg maatvoering</button></div>`

        initWebComponent(this, template)

        this.addEventListener('click', (element) => {
            const classList = element.target.classList
            if(classList.contains('active')) {
                classList.remove('active')
                setGeoJsonLayerSegments(featureIndex, index)
                setSegmentStyleVisible(false)
                window.measureFeatures = window.measureFeatures.splice(100000, 1)
                window.measurePrintFeatures = []
            } else {
                classList.add('active')
                setGeoJsonLayerSegments(featureIndex, index, false)
                setSegmentStyleVisible(true)
            }
        })
    }
}

